<template>
  <div class="container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardContainerDorderDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doorder"> Dashboard</h4>
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DashboardCard from "@/components/dashboard/Card";
// import DashboardTable from "@/components/dashboard/Table";
// import DashboardStatistics from "@/components/dashboard/StatisticsChart";
// import DashboardStatisticsData from "@/components/dashboard/StatisticsData";
// import DashboardRevenueChart from "@/components/dashboard/RevenueChart";
// import DashboardRevenueData from "@/components/dashboard/RevenueData";

export default {
  name: "DoorderDashboard",
  components: {
  },
  data() {
    return {
    };
  },
  methods: {},
  mounted(){
      console.log(window.localStorage.getItem("user"))
  }
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/Dashboard.vue